module.exports = __webpack_public_path__ + "static/media/znyx.538fd329.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/znyx.png
// module id = 1888
// module chunks = 0 1